<template>
  <div>
    <template>
      <div>
        <BaseBusiness :formParams='formParamsBase' ref="base" :opCode="opCode"></BaseBusiness>
      </div>
    </template>
    <SubTabs :elements="tabs.elements" :styles='tabs.styles'>
      <template v-slot:tabsContent>
        <div style="margin-top: 15px;">
          <VoiceBusiness :formParams='formParamsVoice' ref="voice" :info='voiceBusinessInfo' :gmsInfo='voiceBusinessInfoGroup' :opCode="opCode"></VoiceBusiness>
        </div>
        <div style="margin-top: 15px;">
          <DataBusiness :formParams='formParamsData' ref="data" :info='dataBusinessInfo' :gmsInfo='dataBusinessInfoGroup' :opCode="opCode"></DataBusiness>
        </div>
        <div style="margin-top: 15px;">
          <VideoBusiness :formParams='formParamsVideo' ref="video" :info='videoBusinessInfo' :gmsInfo='videoBusinessInfoGroup' :opCode="opCode"></VideoBusiness>
        </div>
      </template>
    </SubTabs>
  </div>
</template>

<script>
import BaseBusiness from '../U_BaseBusiness';
import VoiceBusiness from '../U_VoiceBusiness';
import DataBusiness from '../U_DataBusiness';
import VideoBusiness from '../U_VideoBussiness';
import SubTabs from '../../../util/SubTabs';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import commonJs from '../../common';

export default {
  name: 'AddUserDialog',
  components: {
    SubTabs,
    BaseBusiness,
    VoiceBusiness,
    DataBusiness,
    VideoBusiness,
  },
  mixins: [commonJs],
  props: [
    'opCode',
    'neid',
    'gmsNeid'
  ],
  methods: {
    mainHandler(data = []) {
      const $this = this;
      let arrBase = null;
      let arrVioce = null;
      let arrData = null;
      let arrVideo = null;
      const params = {
        msgid: this.msg.addUser,
        neid: this.neid
      };
      // $this.$loading.showLoadding();
      $this.voiceBusinessInfo = this.setInfo(this.msg.qryUsers);
      $this.dataBusinessInfo = this.setInfo(this.msg.qryUsers);
      $this.videoBusinessInfo = this.setInfo(this.msg.qryUsers);
      $this.voiceBusinessInfoGroup = this.setGroupInfo(this.msg.qryGroups);
      $this.dataBusinessInfoGroup = this.setGroupInfo(this.msg.qryGroups);
      $this.videoBusinessInfoGroup = this.setGroupInfo(this.msg.qryGroups);
      this.$axios.post('/lte/ems/subscriber/mcs/getParamJson', params).then((response) => {
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        data = this.initAnotherBussinessDatas(data);
        const resultMap = sub.$devideByGroupBy(res, data);
        arrBase = resultMap.get($this.formParamsBase.modelName);
        $this.formParamsBase = arrBase;

        arrVioce = resultMap.get($this.formParamsVoice.modelName);
        $this.formParamsVoice = arrVioce;

        arrData = resultMap.get($this.formParamsData.modelName);
        $this.formParamsData = arrData;

        arrVideo = resultMap.get($this.formParamsVideo.modelName);
        $this.formParamsVideo = arrVideo;
      });
    },

    setInfo(msgid) {
      return {
        neid: this.neid,
        msgid: msgid
      };
    },

    setGroupInfo(msgid) {
      return {
        neid: this.gmsNeid,
        msgid: msgid
      };
    },

    getDatas() {
      const validateReturn = this.$refs.base.validateResult() === false
        ? false : (this.$refs.voice.validateResult() === false
          ? false : (this.$refs.data.validateResult() === false
            ? false : (this.$refs.video.validateResult() === false
              ? false : true)));
      if (!validateReturn) {
        console.log('表单验证不通过');
        return false;
      }
      const map = this.$refs.base.getDatas();
      const mapVoice = this.$refs.voice.getDatas();
      const mapData = this.$refs.data.getDatas();
      const mapVideo = this.$refs.video.getDatas();
      let returnObj = {};
      Array.from(map).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVoice).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapData).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVideo).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      returnObj = this.getAnotherBussiness(returnObj);
      return returnObj;
    },
    getAnotherBussiness(returnObj) {
      returnObj.mcdata_userAlias = returnObj.mcptt_userAlias;
      returnObj.mcvideo_userAlias = returnObj.mcptt_userAlias;

      returnObj.mcdata_participantType = returnObj.mcptt_participantType;
      returnObj.mcvideo_participantType = returnObj.mcptt_participantType;

      if (this.opCode === 0) {
        returnObj.mcptt = returnObj.userNum;
        returnObj.mcdata = returnObj.userNum;
        returnObj.mcvideo = returnObj.userNum;
      }

      returnObj.password = returnObj['password[origin]'];

      const sdslist = () => {
        const list = [];
        for (let i = 0; i < 16; i++) {
          list.push('');
        }
        return list;
      };
      returnObj.sdslist = sdslist();
      return returnObj;
    },
    initAnotherBussinessDatas(datas) {
      datas['password[origin]'] = datas.password;
      datas['password[confirm]'] = datas.password;
      return datas;
    },
  },
  data() {
    return {
      funcMap: new Map(),
      tabs: {
        elements: {
          refName: 'xxxxx',
          items: [
            { header: this.$t('MCS.voiceBusiness'), contentKey: 'item1-content' },
            { header: this.$t('MCS.dataBusiness'), contentKey: 'item2-content' },
            { header: this.$t('MCS.videoBusiness'), contentKey: 'item3-content' },
          ]
        },
        styles: {
          heightMode: 'Auto'
        }
      },
      formParamsBase: {
        modelName: 'base',
      },
      formParamsVoice: {
        modelName: 'voice',
      },
      formParamsData: {
        modelName: 'data',
      },
      formParamsVideo: {
        modelName: 'video',
      },
      baseBusinessInfo: '',
      voiceBusinessInfo: '',
      dataBusinessInfo: '',
      videoBusinessInfo: '',
      voiceBusinessInfoGroup: '',
      dataBusinessInfoGroup: '',
      videoBusinessInfoGroup: ''
    };
  },
};
</script>
